import { useState } from 'react';
import { isFuture, parseISO } from 'date-fns';

import { ReactComponent as ReminderSVG } from 'icons/sd-reminder.svg';
import { ReactComponent as DeleteSVG } from 'icons/delete.svg';
import Modal from 'components/modal/delete';

import { deleteReminder } from 'api/reminder';

import useWindowDimensions, {
  isMobileResolution,
} from 'helpers/useWindowDimensions';

const generateFullName = (user) =>
  user ? [user.firstName, user.lastName].filter(Boolean).join(' ') : null;

const ReminderCard = ({ data, date }) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const { width } = useWindowDimensions();
  const isMobile = isMobileResolution(width);

  const { id, user, calendlyEvent } = data;

  const handleDelete = async (id) => {
    await deleteReminder(id);
    setDeleteModalOpen(false);
    window.location.reload();
  };

  const DesktopView = (
    <>
      <article className="grid-cards pointer">
        <div
          className="apps-card-left-new"
          style={{ gridColumn: 'span 10' }}
          onClick={() => null}
        >
          <div className="mr6">
            <ReminderSVG />
          </div>
          <div className="apps-card-meta">
            <div className="apps-card-app-title-new">
              Reminder about {calendlyEvent.name}
            </div>
            <div className="flex flex-row" style={{ gap: '6px' }}>
              <div>
                {user && <p className="apps-card-app-desc-new">Created by:</p>}
              </div>
              <div className="flex flex-column">
                {user && (
                  <p className="apps-card-app-desc-new">
                    {generateFullName(user[user.role])}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="apps-card-right-new"
          style={{ gridColumn: 'span 2', justifySelf: 'end' }}
        >
          {isFuture(parseISO(data.reminderDate)) && (
            <div className="mr10 pt1" onClick={() => setDeleteModalOpen(true)}>
              <DeleteSVG />
            </div>
          )}
          <div>
            <p className="apps-card-app-desc-new">Reminder date:</p>
            <p className="apps-card-app-desc-new">{date}</p>
          </div>
        </div>
      </article>
      {deleteModalOpen && (
        <Modal
          title="Delete reminder"
          content={`Are you sure you would like  to delete this reminder`}
          onClickOutside={() => setDeleteModalOpen(false)}
          onClose={() => setDeleteModalOpen(false)}
          onDelete={() => handleDelete(id)}
        />
      )}
    </>
  );

  const MobileView = (
    <>
      <article className="grid-cards pointer" onClick={() => null}>
        <div className="apps-card-left-new" style={{ gridColumn: 'span 10' }}>
          <div className="apps-card-meta ">
            <div className="apps-card-app-title-new">
              Reminder about {calendlyEvent.name}
            </div>
            <div className="flex flex-row" style={{ gap: '6px' }}>
              <div>
                {user && <p className="apps-card-app-desc-new">Created by:</p>}
              </div>
              <div className="flex flex-column">
                {user && (
                  <p className="apps-card-app-desc-new">
                    {generateFullName(user[user.role])}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="apps-card-right-new"
          style={{ gridColumn: 'span 2', justifySelf: 'end' }}
        >
          {isFuture(parseISO(data.reminderDate)) && (
            <div className="mr10 pt1" onClick={() => setDeleteModalOpen(true)}>
              <DeleteSVG />
            </div>
          )}
          <div>
            <p className="apps-card-app-desc-new">Reminder date:</p>
            <p className="apps-card-app-desc-new">{date}</p>
          </div>
        </div>
      </article>
      {deleteModalOpen && (
        <Modal
          title="Delete reminder"
          content={`Are you sure you would like  to delete this reminder`}
          onClickOutside={() => setDeleteModalOpen(false)}
          onClose={() => setDeleteModalOpen(false)}
          onDelete={() => handleDelete(id)}
        />
      )}
    </>
  );

  return isMobile ? MobileView : DesktopView;
};

export default ReminderCard;
